import type { Part } from '../../domain/inventory';
import { compareDisplayLabels, humanizeIdentifier } from '../../lib/formatting';

export function uniquePartTypes(parts: Part[]): string[] {
  return [...new Set(parts.map((part) => part.type))].sort((left, right) =>
    compareDisplayLabels(humanizeIdentifier(left), humanizeIdentifier(right)),
  );
}

export function partIdsForType(parts: Part[], partType: string): string[] {
  if (!partType) return [];
  return parts.filter((part) => part.type === partType).map((part) => part.id);
}
